var $4b8af785a70e5b4e$exports = {};
$4b8af785a70e5b4e$exports = {
    "loading": `Laster inn ...`,
    "loadingMore": `Laster inn flere ...`
};


export {$4b8af785a70e5b4e$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
